import React, { Suspense, Fragment, lazy } from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import Loader from "./components/Loader/Loader";
import AdminLayout from "./layouts/AdminLayout";

import GuestGuard from "./components/Auth/GuestGuard";
import AuthGuard from "./components/Auth/AuthGaurd1";

import { BASE_URL } from "./config/constant";
import RecommendationGaurd from "./components/Auth/RecommendationGaurd";
import OTPValidationGaurd from "./components/Auth/OtpValidationGaurd";

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;
        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    guard: GuestGuard,
    path: "/auth/register",
    component: lazy(() => import("./views/auth/signup/Register")),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: "/auth/login",
    component: lazy(() => import("./views/auth/signin/Login")),
  },
  {
    exact: true,
    guard: OTPValidationGaurd,
    path: "/auth/validate-otp",
    component: lazy(() => import("./views/auth/signin/OtpLogin")),
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("./views/errors/NotFound404")),
  },
  {
    exact: true,
    path: "/maintenance/coming-soon",
    component: lazy(() => import("./views/maintenance/ComingSoon")),
  },
  {
    exact: true,
    path: "/maintenance/error",
    component: lazy(() => import("./views/maintenance/Error")),
  },
  {
    exact: true,
    path: "/maintenance/offline-ui",
    component: lazy(() => import("./views/maintenance/OfflineUI")),
  },
  {
    exact: true,
    path: "/auth/reset-password",
    component: lazy(() => import("./views/auth/reset-password/ResetPassword1")),
  },
  {
    exact: true,
    path: "/auth/create-password/:id",
    component: lazy(() => import("./views/auth/reset-password/CreatePassword")),
  },
  {
    path: "*",
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: true,
        path: "/app/dashboard",
        component: lazy(() => import("./views/dashboard/DashDefault")),
      },
      {
        exact: true,
        path: "/app/partskart-dashboard",
        component: lazy(() =>
          import("./views/dashboard/DashDefault/partsKartIndex")
        ),
      },
      {
        exact: true,
        guard: RecommendationGaurd,
        path: "/users/userlist",
        component: lazy(() => import("./views/users/UsersTable")),
      },
      {
        exact: true,
        guard: RecommendationGaurd,
        path: "/users/view-logged-users",
        component: lazy(() => import("./views/users/ViewUserLogin")),
      },
      {
        path: "*",
        exact: true,
        component: () => <Redirect to={BASE_URL} />,
      },
    ],
  },
];

export default routes;
